// src/hooks/useMonthlyTicketUsage.js
import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";

export function useMonthlyTicketUsage(projectId) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!projectId) return;

    const start = new Date();
    start.setDate(1);
    start.setHours(0, 0, 0, 0);
    const end = new Date(start.getFullYear(), start.getMonth() + 1, 1);

    const qRef = query(
      collection(db, "projects", projectId, "tickets"),
      where("createdAt", ">=", start),
      where("createdAt", "<", end)
    );

    const unsub = onSnapshot(qRef, (snap) => setCount(snap.size));
    return () => unsub();
  }, [projectId]);

  return { monthlyCount: count, monthlyLimit: 50 };
}
